/**
 * App
 * Using pageName, which is variable in the state, to switch component
 * contact Page content: contactUs, callUs, email
 */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Helper
import { contactPage } from '../constants/UtilVariables';
import { trackSetUp } from '../../lib/analytics-helper';
import Page from '../../lib/page';

// Components
import ContactUs from '../components/ContactUs';
import QuickAnswer from './QuickAnswer';
import HelpTemplate from '../components/HelpTemplate';
import ContactService from '../components/ContactService';
import AlertsContainer from './Alerts';
import Notifier from './Notifier';
import EmailNoIntent from './EmailNoIntent';
import ContactDialing from '../components/ContactDialing';
import { CALLUS_ELMO_TREATMENTS } from '../constants/PropTypesShapes';

const App = (props) => {
  const { callUsElmoTreatments, kanaCode } = props;
  // To switch Channel Steering main content
  function getPageContent({ pageName }) {
    switch (pageName) {
      case contactPage.callUs: {
        Page.scrollToTop();
        // New Call us page redirect with Modal Container handling Email page redirection
        return (
          <div>
            <AlertsContainer />
            <ContactDialing callUsElmoTreatments={callUsElmoTreatments} />
          </div>
        );
      }
      // TODO: Add Email Page content
      case contactPage.email:
        // Send FPTI impression event after receive topic data
        return (
          <div>
            <ContactService
              leftPanel={<EmailNoIntent />}
              rightPanel={<QuickAnswer pageName={pageName} />}
              kanaCode={kanaCode}
            />
          </div>
        );
      case contactPage.success:
        return (
          <div>
            <AlertsContainer />
            <Notifier />
          </div>
        );
      case contactPage.contactUs: {
        trackSetUp({ id: 'contactUsPage', link: 'smarthelp-contact-us' });
        return <ContactUs />;
      }
      default: {
        return null;
      }
    }
  }

  // The main body content has tree different types: EMAIL/CALLUS/CONTACTUS
  const bodyContent = getPageContent({ pageName: props.pageName });

  return (
    <HelpTemplate>
      { bodyContent }
    </HelpTemplate>
  );
};

function mapStateToProps(state) {
  return {
    pageName: state.location.pageName,
    callUsElmoTreatments: state.callUs.callUsElmoTreatments,
    kanaCode: state.emailNoIntent.kanaCode,
  };
}

// App propTypes
App.propTypes = {
  pageName: PropTypes.string.isRequired,
  callUsElmoTreatments: PropTypes.arrayOf(PropTypes.shape(CALLUS_ELMO_TREATMENTS)),
  kanaCode: PropTypes.string.isRequired,
};

App.defaultProps = {
  callUsElmoTreatments: [],
};

export default connect(mapStateToProps)(App);
